/**
 * A sentence-case title for a tool that sends none, from its name:
 * "list_teams" → "List teams", "getIssueById" → "Get issue by id".
 * Acronyms and their plurals keep their case ("listPRs" → "List PRs") unless
 * the whole name is upper case.
 */
export function toolTitleFromName(name: string): string {
  const shouting = name === name.toUpperCase();
  const words = name
    .split(/[_\-./\s]+/)
    .flatMap((part) =>
      part.split(/(?<=[a-z0-9])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])(?![A-Z]s$)/),
    )
    .filter(Boolean)
    .map((word) => {
      const stem = word.replace(/(?<=[A-Z])s$/, "");
      return !shouting && stem.length > 1 && stem === stem.toUpperCase()
        ? word
        : word.toLowerCase();
    });
  if (words.length === 0) return name;
  const sentence = words.join(" ");
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
}
